import React, { type ReactNode } from "react";

interface SectionProps {
  title: string;
  description?: string;
  children: ReactNode;
}

export function Section({ title, description, children }: SectionProps) {
  return (
    <section className="mt-12">
      <div className="mb-4 border-b-2 border-ink pb-2">
        <h2 className="font-mono text-xs font-bold uppercase tracking-[0.2em] text-ink">
          {title}
        </h2>
        {description ? (
          <p className="mt-1 text-sm text-muted">{description}</p>
        ) : null}
      </div>
      <div>{children}</div>
    </section>
  );
}
